/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';

import {
  SizeType,
  KindDisplayNameType,
} from '@zapier/product-get-help/src/types';

import AppIncidents from '@zapier/product-get-help/src/components/other/Incidents/AppIncidents';
import CollapsedBlock from '@zapier/product-get-help/src/components/blocks/CollapsedBlock';

import ZapIcons from '../ZapIcons';
import { DEFAULT_ZAP_NAME } from '../constants';
import { getSelectedZap } from '../utils';

import { DataType, ZapType } from '../useData';

type ClosedProps = {
  title: string;
  onClickEdit: () => void;
  onSelect: (item: ZapType) => void;
  selectedZap?: ZapType | string | null;
  isConfirming?: boolean;
  data: DataType;
  disableIncidents?: boolean;
  isLoading?: boolean;
  size: SizeType;
  kindDisplayName: KindDisplayNameType;
};

const gridCss = css`
  align-items: center;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: min-content 1fr;
`;

/** Renders `<ZapBlock>` when it is closed. */
const Closed = ({
  data,
  disableIncidents = false,
  isConfirming = false,
  isLoading = false,
  kindDisplayName,
  onClickEdit,
  onSelect,
  selectedZap: _selectedZap,
  size,
  title,
}: ClosedProps) => {
  const selectedZap = getSelectedZap({
    data,
    isLoading,
    onSelect,
    selectedZap: _selectedZap,
  });
  const selectedApis = selectedZap
    ? selectedZap.nodes
        .map<string>(({ selectedApi }) => selectedApi || '')
        .filter(selectedApi => !!selectedApi)
    : [];

  const footer =
    !disableIncidents && selectedApis.length > 0 ? (
      <AppIncidents implementationIds={selectedApis} />
    ) : null;

  return (
    <CollapsedBlock
      footer={footer}
      isDimmed={!isConfirming}
      onClickEdit={onClickEdit}
      size={size}
      title={title}
    >
      {selectedZap ? (
        <div css={gridCss}>
          <ZapIcons nodes={selectedZap.nodes} />{' '}
          <span>{selectedZap.title || DEFAULT_ZAP_NAME}</span>
        </div>
      ) : (
        <p>You have not selected a {kindDisplayName}.</p>
      )}
    </CollapsedBlock>
  );
};

export default Closed;
